import { render } from "./SpaDayDining.vue?vue&type=template&id=12db0bee&scoped=true"
import script from "./SpaDayDining.vue?vue&type=script&lang=js"
export * from "./SpaDayDining.vue?vue&type=script&lang=js"

import "./SpaDayDining.vue?vue&type=style&index=0&id=12db0bee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12db0bee"]])

export default __exports__